<template>
  <div class="e-compony" v-if="compony">
    <p class="top-nav w">
      <router-link to="/">首页</router-link> / <span>公司信息</span>
    </p>
    <div class="e-top">
      <div class="w">
        <div class="img">
          <img :src="compony.img ? `${publicPath}images/${ compony.name }.jpg` : `${publicPath}images/logo-default.png`" alt="">
        </div>
        <div class="info">
          <router-link class="top-m-nav" to="/">
            <i class="iconfont icon-zuojiantou"></i>
            公司信息
          </router-link>
          <p class="title">{{ compony.name }}</p>
          <p class="desc">{{ compony.desc }}</p>
        </div>
      </div>
    </div>
    <ul class="e-tags w">
      <li v-for="(tag, tagIndex) in compony.tags" :key="tagIndex">{{ tag }}</li>
    </ul>
    <div class="e-body w">
      <div class="info">
        <ul class="nav">
          <li @click="active = 'intro'" :class="active === 'intro' ? 'act' : ''">公司简介</li>
          <li @click="active = 'list'" :class="active === 'list' ? 'act' : ''">招聘职位</li>
        </ul>
        <div class="intro" v-if="active === 'intro'">
          <p>{{ compony.intro }}</p>
        </div>
        <ul class="list" v-if="active === 'list'">
          <li @click="$router.push(`/claim/${componyIndex}/${jdIndex}`)" v-for="(jd, jdIndex) in compony.jds" :key="jdIndex">
            <div class="detail">
              <p class="name">{{ jd.name }}</p>
              <p class="desc">{{ jd.city || compony.city }}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;{{ jd.edu || '无需求' }}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;{{ jd.type }}</p>
            </div>
            <div class="salary">{{ jd.salary }}</div>
            <div class="btn" @click="$router.push(`/claim/${componyIndex}/${jdIndex}`)">了解详情</div>
          </li>
        </ul>
      </div>
      <compony-info/>
    </div>
  </div>
</template>

<script>
import componys from '@/data.js'
import componyInfo from '@/views/components/ComponyInfo';
import vxShare from '@/util/vxShare.js'

export default {
  data () {
    return {
      active: 'list',
      compony: null,
      componyIndex: null
    }
  },
  components: {
    componyInfo
  },
  metaInfo () {
    return {
      title: this.compony.name + '_睿慕课'
    }
  },
  mounted () {
    vxShare()
  },
  created() {
    this.componyIndex = this.$route.params.id
    this.compony = componys[this.$route.params.id]
  }
}
</script>

<style lang="scss" scoped>
.e-compony{
  position: relative;
  .top-nav{
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 27px;
    color: #fff;
    opacity: .75;
    font-size: 13px;
    line-height: 13px;
    a{
      margin-right: 7px;
      color: #fff;
      display: inline-block;
      text-decoration: none;
    }
    span{
      margin-left: 7px;
    }
  }
  .e-top{
    width: 100%;
    height: 170px;
    background: url(../../static/bg_info.png);
    background-size: cover;
    display: flex;
    align-items: flex-end;
    .w{
      position: relative;
      display: flex;
      .img{
        background-color: #fff;
        background-image: url('../../static/logo-default.png');
        background-size: cover;
        width: 150px;
        height: 150px;
        border-radius: 6px;
        border: 1px solid #E7E7E7;
        line-height: 150px;
        margin-bottom: -54px;
        overflow: hidden;
        flex-shrink: 0;
        img{
          vertical-align: top;
          text-align: center;
          width: 100%;
          height: auto;
        }
      }
      .info{
        padding-top: 20px;
        padding-left: 20px;
        .top-m-nav{
          display: none;
        }
        .title{
          font-size: 22px;
          line-height: 28px;
          color: white;
          font-weight: 700;
          margin-bottom: 7px;
        }
        .desc{
          font-size: 14px;
          line-height: 18px;
          overflow: hidden;
          color: #FFFFFF;
          opacity: .6;
        }
      }
    }
  }
  .e-tags{
    padding-left: 170px;
    padding-top: 20px;
    display: flex;
    box-sizing: border-box;
    flex-wrap: wrap;
    li{
      border: 1px solid #5730f1;
      padding: 0 13px;
      line-height: 26px;
      box-sizing: border-box;
      color: #5730f1;
      margin-right: 10px;
      margin-bottom: 10px;
      border-radius: 40px;
      font-size: 13px;
    }
  }
  .e-body{
    padding-bottom: 60px;
    margin-top: 70px;
    display: flex;
    justify-content: space-between;
    .info{
      width: 820px;
      .nav{
        width: 100%;
        border-bottom: 1px solid #F1F1F1;
        display: flex;
        justify-content: flex-start;
        li{
          color: #333333;
          font-size: 16px;
          line-height: 20px;
          margin: 0 22px;
          padding-bottom: 17.5px;
          cursor: pointer;
          font-weight: 700;
          &.act{
            color: #5730f1;
            border-bottom: 2px solid #5730f1;
          }
        }
      }
      .intro{
        padding-top: 30px;
        p{
          font-size: 14px;
          line-height: 26px;
          margin-bottom: 26px;
          color: #313131;
          white-space: pre-wrap;
        }
      }
      .list{
        li{
          height: 106px;
          display: flex;
          align-items: center;
          border-bottom: 1px solid #F1F1F1;
          cursor: pointer;
          &:nth-last-child(1) {
            border: none;
          }
          &:hover{
            background: #F4F4F6;
          }
          .detail{
            padding-left: 20px;
            box-sizing: border-box;
            width: 506px;
            .name{
              font-size: 16px;
              line-height: 20px;
              color: #000000;
              margin-bottom: 10px;
            }
            .desc{
              color: #92969C;
              font-size: 13px;
              line-height: 16px;
            }
          }
          .salary{
            width: 167px;
            font-size: 16px;
            line-height: 20px;
            color: #5730f1;
          }
          .btn{
            width: 132px;
            height: 42px;
            border: 1px solid #5730f1;
            text-align: center;
            line-height: 42px;
            color: #5730f1;
            cursor: pointer;
          }
        }
      }
    }
    .base{
      width: 280px;
    }
  }
}

@media (max-width: 768px){
  .e-compony{
    .e-top{
      width: 100%;
      height: 130px;
      background: url(../../static/m-compony.png);
      background-size: cover;
      display: flex;
      align-items: flex-end;
      padding: 0 15px;
      box-sizing: border-box;
      .w{
        position: static;
        display: flex;
        width: 100%;
        .img{
          width: 85px;
          height: 85px;
          line-height: 85px;
          margin-bottom: -22px;
          img{
            vertical-align: middle;
            text-align: center;
            width: 100%;
            height: auto;
          }
        }
        .info{
          .top-m-nav{
            display: block;
            position: absolute;
            color: #fff;
            opacity: .75;
            font-size: 14px;
            left: 20px;
            top: 23px;
            text-decoration: none;
          }
          padding-top: 7px;
          padding-left: 14px;
          .title{
            font-size: 16px;
            line-height: 20px;
            color: white;
            font-weight: 700;
            margin-bottom: 6px;
          }
          .desc{
            font-size: 12px;
            line-height: 15px;
            height: 30px;
            overflow: hidden;
          }
        }
      }
    }
    .e-tags{
      padding: 0 15px;
      padding-top: 37px;
      display: flex;
      box-sizing: border-box;
      flex-wrap: wrap;
      li{
        border: none;
        background-color: rgba($color: #3387F1, $alpha: .05);
        padding: 0 13px;
        line-height: 21px;
        box-sizing: border-box;
        color: #5730f1;
        margin-right: 8px;
        margin-bottom: 8px;
        border-radius: 40px;
        font-size: 12px;
      }
    }
    .e-body{
      padding-top: 20px;
      border-top: 8px solid #F1F1F1;
      display: block;
      margin-top: 15px;
      .info{
        width: 100%;
        padding: 0 15px;
        box-sizing: border-box;
        .nav{
          width: 100%;
          border-bottom: 1px solid #F1F1F1;
          display: flex;
          justify-content: center;
          li{
            color: #333333;
            font-size: 15px;
            line-height: 19px;
            margin: 0 30px;
            padding-bottom: 14px;
            cursor: pointer;
            font-weight: 700;
            &.act{
              color: #5730f1;
              border-bottom: 2px solid #5730f1;
            }
          }
        }
        .intro{
          padding-top: 30px;
          p{
            font-size: 13px;
            line-height: 26px;
            margin-bottom: 26px;
            color: #313131;
          }
        }
        .list{
          li{
            height: 80px;
            display: flex;
            justify-content: center;
            align-items: center;
            &:hover{
              background: #F4F4F6;
            }
            .detail{
              box-sizing: border-box;
              padding-left: 0;
              .name{
                font-size: 16px;
                line-height: 20px;
                color: #000000;
                margin-bottom: 10px;
                height: 20px;
                overflow: hidden;
              }
              .desc{
                color: #92969C;
                font-size: 13px;
                line-height: 16px;
              }
            }
            .salary{
              width: 80px;
              font-size: 16px;
              line-height: 20px;
              color: #5730f1;
              flex-shrink: 0;
            }
            .btn{
              display: none;
              font-size: 13px;
              width: 76px;
              height: 32px;
              border: 1px solid #5730f1;
              text-align: center;
              line-height: 32px;
              color: #5730f1;
              cursor: pointer;
              flex-shrink: 0;
              border-radius: 40px;
              box-sizing: border-box;
            }
          }
        }
      }
      .base{
        width: 280px;
      }
    }
  }
}
</style>

